import { PageHero } from '@/components/ui/PageHero'
import { productOne } from '@/assets/siteMedia'

export const ProductsHero = () => (
  <PageHero
    image={productOne}
    imageAlt="Instrumental Health herbal product sample"
    highlights={['Tinctures', 'Teas', 'Herbal formulations']}
    title="Herbal"
    accent="Products"
    description={
      <>
        <p>
          Handcrafted tinctures, teas, and herbal formulations developed over 20+ years of clinical
          practice, drawing on African, Caribbean, and traditional European healing wisdom.
        </p>
        <p className="text-sm text-green-200">
          All formulations developed by Kandake Makonnen · BSc (Hons) Medical Herbalist
        </p>
      </>
    }
  />
)
